import * as T from '../constants/types';

const initialState = [];

export const notifications = (state = initialState, { type, payload }) => {
    switch (type) {
        case T.THROW_NOTIFICATION:
        case T.CLOSE_NOTIFICATION:
        case T.CLOSE_ALL_NOTIFICATIONS: {
            return payload;
        }
        default: return state;
    }
};
